import React, { useState } from 'react'
import { Input, TextareaAutosize } from './'
import { companyService } from '../services'

const val = (e) => (e.target !== undefined ? e.target.value : e.value)

// Shared create/edit form for a network company — used both by the Nätverk
// company page (network/hooks/useNetworkDialog.js) and CompanyPicker's
// "+ Skapa" create flow (mode="uuid"), so there is exactly one company form
// in the app. `company` prefills values AND switches the submit to an
// update; pass `initialName` instead when you only want to prefill a fresh
// create (e.g. from a picker's search term).
export const CompanyEditForm = ({ company, initialName, dialogRef, hideModalDialog, setLoadingModalDialog, onSaved }) => {
  const [state, setState] = useState({
    company_name: company?.company_name || initialName || '',
    company_industry: company?.company_industry || '',
    company_industry_en: company?.company_industry_en || '',
    company_website: company?.company_website || '',
    company_notes: company?.company_notes || '',
  })
  const [error, setError] = useState(null)

  const set = (key, v) => setState(prev => ({ ...prev, [key]: v }))

  const submit = () => {
    setError(null)

    if (!state.company_name || !state.company_name.trim()) {
      setError('Företagsnamn krävs')
      return Promise.resolve()
    }

    setLoadingModalDialog(true)
    const call = company
      ? companyService.update(company.company_uuid, state)
      : companyService.create(state)

    return call
      .then(res => {
        setLoadingModalDialog(false)
        hideModalDialog()
        onSaved && onSaved(res.company)
      })
      .catch(err => {
        setLoadingModalDialog(false)
        setError(err.message || 'Kunde inte spara företag')
      })
  }

  if (dialogRef) dialogRef.current = { submit }

  return (
    <div className="network-form">
      {error && <div className="form-error">{error}</div>}
      <Input name="company_name" label="Namn" value={state.company_name} onChange={e => set('company_name', val(e))} />
      <Input name="company_industry" label="Bransch (sv)" value={state.company_industry} onChange={e => set('company_industry', val(e))} />
      <Input name="company_industry_en" label="Bransch (en)" value={state.company_industry_en} onChange={e => set('company_industry_en', val(e))} />
      <Input name="company_website" label="Webbplats" value={state.company_website} onChange={e => set('company_website', val(e))} />
      <label>Anteckningar</label>
      <TextareaAutosize name="company_notes" value={state.company_notes} onChange={e => set('company_notes', val(e))} minRows={4} />
    </div>
  )
}
